<template>
  <div class="nav-header-wrap">
    <div class="container">
      <div class="FBH FBJB header-main">
        <img src="@/assets/logo.png" class="logo" />
        <div class="FB1 TAR nav-list-mobile-main">
          <a-icon type="unordered-list" style="margin: 8px 4px 8px 0" @click="onToggleChange" />
          <div class="nav-list-mobile" style="line-height: 40px" v-if="showMenuDropdown">
            <a @click="onGotoHome">首页</a>
            <a-dropdown placement="bottomCenter" :getPopupContainer="getPopupContainer">
              <a-button type="primary"> 产品介绍 </a-button>
              <a-menu slot="overlay" class="TAC" @click="onGotoModel">
                <!-- 这里的 key 对应 home.vue 里面的 imgs 里面的 index -->
                <a-menu-item key="1">
                  <div>金融智审</div>
                </a-menu-item>
                <a-menu-item key="2">
                  <div>司法区块链</div>
                </a-menu-item>
                <a-menu-item key="3">
                  <div>调解平台</div>
                </a-menu-item>
                <a-menu-item key="4">
                  <div>创新执行</div>
                </a-menu-item>
                <a-menu-item key="5">
                  <div>证券纠纷</div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a @click="onMenuClick('9')">联系我们</a>
            <a @click="onJoinUsClick">加入我们</a>
          </div>
        </div>
        <div class="FB1 TAR nav-list" style="line-height: 40px">
          <a @click="onGotoHome">首页</a>
          <a-dropdown placement="bottomCenter" :getPopupContainer="getPopupContainer">
            <a-button type="primary" class="ML24 MR24"> 产品介绍 <a-icon type="down" class="ML4" /> </a-button>
            <a-menu slot="overlay" class="TAC" @click="onGotoModel">
              <!-- 这里的 key 对应 home.vue 里面的 imgs 里面的 index -->
              <a-menu-item key="1">
                <div>金融智审</div>
              </a-menu-item>
              <a-menu-item key="2">
                <div>司法区块链</div>
              </a-menu-item>
              <a-menu-item key="3">
                <div>调解平台</div>
              </a-menu-item>
              <a-menu-item key="4">
                <div>创新执行</div>
              </a-menu-item>
              <a-menu-item key="5">
                <div>证券纠纷</div>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a @click="onMenuClick('9')" class="MR24">联系我们</a>
          <a @click="onJoinUsClick">加入我们</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onGotoHome: {
      type: Function,
      default: () => {}
    },
    onJoinUsClick: {
      type: Function,
      default: () => {}
    },
    onMenuClick: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      showMenuDropdown: false
    }
  },
  methods: {
    onToggleChange () {
      this.showMenuDropdown = !this.showMenuDropdown
    },
    hideMenuDropdown () {
      this.showMenuDropdown = false
    },
    onGotoModel (e) {
      this.showMenuDropdown = false
      this.onMenuClick(e.key)
    },
    getPopupContainer () {
      return document.querySelector('.nav-header-wrap')
    }
  }
}
</script>

<style lang="less" scoped>
.nav-header-wrap {
  padding: 8px 0;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 10px 2px #ccc;
  z-index: 999;
  .logo {
    height: 40px;
    width: 275px;
  }
  .nav-list-mobile-main {
    position: relative;
    display: none;
    .anticon {
      color: #158dff;
      font-size: 24px;
    }
    .nav-list-mobile {
      position: absolute;
      top: 46px;
      right: 0;
      width: 260px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      text-align: center;
      background-color: #fff;
    }
  }
}
@media screen and (max-width: 520px) {
  .nav-header-wrap {
    // .header-main {
    //   flex-direction: column;
    // }
    .nav-list-mobile-main {
      display: block;
    }
    .nav-list {
      text-align: center;
    }
    .nav-list {
      display: none;
    }
    .nav-list-mobile {
      display: block;
    }
  }
}
</style>
